<div class="radio-button-container">
  <div class="question-header">
    <h6 class="m-0 p-0"
    [style.font-size]="questionnaire?.mainContentTemplate?.questionStyle?.fontSize + 'px'"
    [style.font-family]="questionnaire?.mainContentTemplate?.questionStyle?.fontFamily"
    [style.font-weight]="questionnaire?.mainContentTemplate?.questionStyle?.boldStyle"
    [style.color]="questionnaire?.mainContentTemplate?.questionStyle?.fontColor"
    >
      {{ questionNumber }}. {{ question?.question || 'Untitled Question' | titlecase }}
      @if (question?.required) {
        <span 
        [style.font-size]="'18px'"
        [style.font-family]="questionnaire?.mainContentTemplate?.errorMessageStyle?.fontFamily"
        [style.font-weight]="questionnaire?.mainContentTemplate?.errorMessageStyle?.boldStyle"
        [style.color]="questionnaire?.mainContentTemplate?.errorMessageStyle?.fontColor"
        >*</span>
      }
    </h6>
  </div>

  <div class="question-content-radio" [ngClass]="getAlignmentClass(question)">
    @for (option of question?.questionOptions; track option.optionId) {
      <div class="radio-option">
        <label class="radio-label">
          <input
            type="radio"
            name="radio-{{ question?.questionId }}"
            [value]="option.optionId"
            [checked]="selectedValue === option.optionId"
            [disabled]="disabled"
            (change)="selectOption(option.optionId)"
          />
          <span class="custom-radio"></span>
          <span 
          [style.font-size]="questionnaire?.mainContentTemplate?.choiceStyle?.fontSize + 'px'"
          [style.font-family]="questionnaire?.mainContentTemplate?.choiceStyle?.fontFamily"
          [style.font-weight]="questionnaire?.mainContentTemplate?.choiceStyle?.boldStyle"
          [style.color]="questionnaire?.mainContentTemplate?.choiceStyle?.fontColor"
          >{{ option.text | titlecase }}</span>
        </label>
      </div>
    }
  </div>

  @if (isOthersSelected()) {
    <div class="others-input-container">
      <input
        type="text"
        class="others-input"
        [ngModel]="othersText"
        placeholder="Please specify"
        (ngModelChange)="onOthersTextChange($event)"
        (blur)=" onOthersInputBlur()"
      />
    </div>
  }

  <!-- @if (isInvalid && errorMessage) {
    <div class="error-message">
      {{ errorMessage }}
    </div>
  } -->
</div>
